import { createSlice } from '@reduxjs/toolkit'

import { LocalStorageKey } from '@/constants/localStorageKeys'
import cookieService from '@/utils/cookies'
import localStorageService from '@/utils/localStorage'

export interface AuthSliceState {
  token: string | undefined
}

const initialState: AuthSliceState = {
  token: undefined,
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action) => {
      const session = action.payload
      localStorageService.add(LocalStorageKey.token, session.token)
      state.token = session.token
    },
    removeSession: (state) => {
      localStorageService.remove(LocalStorageKey.token)
      cookieService.removeCloudFrontCookies()
      state.token = initialState.token
    },
  },
})
export const { setSession, removeSession } = sessionSlice.actions

export default sessionSlice.reducer
